import { faPagelines } from "@fortawesome/free-brands-svg-icons";
import {
  faCalendarCheck,
  faCopy,
  faEnvelope,
  faQuestionCircle,
  faShoppingCart,
  faStore,
} from "@fortawesome/free-solid-svg-icons";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import CreatePrescriptionIcon from "../../assets/images/create_prescription_icon.png";
import DashboardIcon from "../../assets/images/dashboard_icon.png";
import PatientIcon from "../../assets/images/patients.png";
import PrescriptionIcon from "../../assets/images/prescriptions_icon.png";
import fullscript from "../../assets/images/fullscript.svg";
import SideMenuItem from "../SideMenuItem";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getUserDetail } from "../../utils/helper";
const SideMenu = () => {
  const role = useSelector((state) => state.role.role);
  const notification = useSelector((state) => state.dashboard.notification);
  const [localStorageValue, setLocalStorageValue] = useState(getUserDetail());

  useEffect(() => {
    const handleStorageChange = () => {
      setLocalStorageValue(getUserDetail());
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);
  const getItems = (role) => {
    if (role.val === 3) {
      return (
        <>
          <SideMenuItem
            text="prescriptions"
            type="image"
            icon={PrescriptionIcon}
            path="/app/prescriptions"
            notification={notification.num_unordered_rxs}
          />
          <SideMenuItem
            text="practitioners"
            type="image"
            icon={PatientIcon}
            path="/app/practitioners"
            notification={notification.num_pending_practitioner}
          />
        </>
      );
    } else {
      return (
        <>
          <SideMenuItem
            text="create prescription"
            type="image"
            icon={CreatePrescriptionIcon}
            path="/app/prescription"
          />
          <SideMenuItem
            text="prescriptions"
            type="image"
            icon={PrescriptionIcon}
            path="/app/prescriptions"
            notification={notification.num_refill_request}
          />
          <SideMenuItem
            text="patients"
            type="image"
            icon={PatientIcon}
            path="/app/patients"
            notification={notification.num_pending_patient}
          />
          <SideMenuItem
            text="your formulas"
            icon={faPagelines}
            path="/app/formulas"
          />
        </>
      );
    }
  };

  return (
    <div className="sidemenu">
      <div className="content">
        <ul>
          <SideMenuItem
            type="image"
            text="dashboard"
            icon={DashboardIcon}
            path="/app"
          />
          {role && getItems(role)}
          <SideMenuItem text="orders" icon={faCopy} path="/app/orders" />
          {/* <SideMenuItem
            text="store"
            icon={faStore}
            isActive={false}
            path="/app/store"
          /> */}
          <SideMenuItem
            text="shopping cart"
            icon={faShoppingCart}
            path="/app/shopping"
            notification={notification.num_cart_items}
          />

          <SideMenuItem
            text="contact"
            icon={faEnvelope}
            isActive={false}
            path="/app/contact"
          />
          {/* <SideMenuItem text="faqs" icon={faQuestionCircle} path="/app/faq" /> */}
        </ul>
      </div>
    </div>
  );
};

export default SideMenu;
